import { staticChartLegend } from './../../shared/data/dashboard/e-commerce';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiRequestService } from '@app/_services/api-Services/api-request.service';
import { UserLicence } from '@app/shared/model/userLicence.model';
import { ModalDismissReasons, NgbDropdownModule, NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DataTablesModule } from 'angular-datatables';
import { ToastrService } from 'ngx-toastr';
import { max, Observable, Subject } from 'rxjs';
import { LabelType, NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { LicenseType } from '@app/shared/utilities/constants';
import { UtilityService } from '@app/utilities/utility.service';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MaterialModule } from '@app/shared/sharedModules/shared-material.service';
import { LoadingService } from '@app/_services/LoadingService/loading.service';

@Component({
  selector: 'app-addlicence',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbModule,
    TranslateModule,
    DataTablesModule,
    NgxSliderModule,
    TranslateModule,
    MatOptionModule,
    MaterialModule,
    MatSelectModule
  ],
  templateUrl: './addlicence.component.html',
  styleUrl: './addlicence.component.scss'
})
export class AddlicenceComponent implements OnInit, OnDestroy,AfterViewInit {
  simpleSliderControl: FormControl = new FormControl(100);
  public url: any;
  licenceType = LicenseType;
  initializeDbForm : FormGroup;
  createDbForm : FormGroup;
  closeResult: string;
  mode: 'add' | 'edit' = 'add';
  isDataTableInitialized = false;
  licenceUserForm: FormGroup;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  selectAll = false;
  selectedLicenceUser: UserLicence | null = null;
  dropdownOpen = false;
  isActive: boolean = true;
  public searchText: any;
  total$: Observable<number>;
  licenceUsers: UserLicence[] = [];
  sqlInstances: any = [];
  loadingInstance: boolean = true; // Flag to track loading state
  errorInstance: boolean = false;  // Flag to track error state

  testConnectionSuccess : boolean = false;
  connectionData: any = {
    server: '',
    username: '',
    password: '',
  };
  connectionDetails : any = {
    companyId: 0,  
    databaseName: '',
    connectionDetails: {
      server: '',
      username: '',
      password: ''
    }
  };
  databaseName: string = '';
  dbInitializePOV : number = 1;
  companyIdForExecute : number = 0;
  previewLogo: string;
  constructor( 
    private formbuilder: FormBuilder,
    config: NgbModalConfig,
     private modalService: NgbModal,
     private toastrService : ToastrService,
     private cdRef : ChangeDetectorRef,
     private apiRequestService: ApiRequestService,
     private utils: UtilityService,
     private loaderService: LoadingService,
     ) {
  	// customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = false;
}

ngOnInit(): void {
  this.initializeForm();
  this.dtOptions = {
    pagingType: 'full_numbers',
    pageLength: 10,
    lengthMenu: [5, 10, 25],
    // destroy: true
  };
  this.getLicenceUsers(); // Load data
  // this.getSqlInstances();
}

initializeForm() {
  this.licenceUserForm = this.formbuilder.group({
    id: [0],
    companyCode: ['', [Validators.required, Validators.maxLength(100)]],
    companyName: ['', [Validators.required, Validators.maxLength(255)]],
    logo: [''],
    companyEmail: ['', [Validators.required, Validators.email, Validators.maxLength(255)]],
    noOfUsers: [0, [Validators.required, Validators.min(1)]],
    isActive: [true],
    licenseType: [this.licenceType.Demo, [Validators.required]],  // LicenseType moved here
    startDate: ['', [Validators.required]],  // Date field for start date
    endDate: ['', [Validators.required]],    // Date field for end date
    companyDetail: this.formbuilder.group({
      id: [0],
      companyId: [0],
      connectionString: ['string'],
      databaseName: ['string'],
      authenticationMode: ['string'],
    }),
  });
  this.initializeDbForm = this.formbuilder.group({
    server: [0,[Validators.required]],
    username: ['', [Validators.required, Validators.maxLength(128)]],
    password: ['', [Validators.required, Validators.maxLength(128)]],
    databaseName: [{ value: '', disabled: true }, [Validators.required, Validators.maxLength(128)]],
    });
  this.createDbForm = this.formbuilder.group({
    server: [0,[Validators.required]],
    username: ['', [Validators.required, Validators.maxLength(128)]],
    password: ['', [Validators.required, Validators.maxLength(128)]],
    databaseName: ['', [Validators.required, Validators.maxLength(128)]]
  });
}
onDatabaseNameClick(): void {
  const databaseNameControl = this.initializeDbForm.get('databaseName');
  if (databaseNameControl?.disabled) {
    this.toastrService.warning('Please test the connection first to enter the database name.', 'Warning');
  }
}
onUsernamePasswordClick(field: string): void {
  const serverControl = this.initializeDbForm.get('server');
  const usernameControl = this.initializeDbForm.get('username');
  const passwordControl = this.initializeDbForm.get('password');

  // if (serverControl?.value === 0) {  // Check if the server is not selected (assuming 0 is an invalid or unselected value)
  //   this.toastrService.warning('Please select a server instance first.', 'Warning');
  // }
  
  // Additional checks if the username or password fields are clicked (if needed)
  if ((field === 'username' && usernameControl?.touched) || (field === 'password' && passwordControl?.touched)) {
    if (serverControl?.value === 0) {
      this.toastrService.warning('Please select a server instance first before entering username and password.', 'Warning');
    }
  }
}
getLicenceType(status: number): string {
  switch (status) {
    case this.licenceType.Demo:
      return 'Demo';
    case this.licenceType.Standard:
      return 'Standard';
    case this.licenceType.Enterprise:
      return 'Enterprise';
    default:
      return 'Unknown';
  }
}
openModalForAdd(content: any): void {
  this.initializeForm()
  this.previewLogo = ''
  this.mode = 'add'; // Set mode to 'add'

  // Reset the form
  this.licenceUserForm.reset({
    id: 0,
    companyCode: '',
    companyName: '',
    logo: '',
    companyEmail: '',
    noOfUsers: 0,
    isActive: true,
    licenseType: LicenseType.Demo, // Default to Demo
    startDate: '',
    endDate: '',
    companyDetail: {
      id: 0,
      companyId: 0,
      connectionString: 'string',
      databaseName: 'string',
      authenticationMode: 'string',
    },
  });

  this.open(content);
}
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' }).result.then(
      (result) => {

      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  cancelForm(modal: any): void {
    // You can add any custom logic here if necessary
    //this.resetForm();  // Reset the form if needed
    this.previewLogo = ''
    modal.dismiss('Cancel click');  // Close the modal
  }
  readUrl(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        // Convert the file to base64
        const base64Image = reader.result as string;
        // Set the base64 image in the form control for logo
        this.licenceUserForm.patchValue({
          logo: base64Image
        });
        // Set the image preview (optional)
        this.previewLogo = base64Image;
      };
      reader.readAsDataURL(file); // Convert the image to base64
    }
  }
  openModalForEdit(user: UserLicence, content: any): void {
    this.mode = 'edit';
    this.selectedLicenceUser = user;
  
    this.licenceUserForm.setValue({
      id: user.id,
      companyCode: user.companyCode,
      companyName: user.companyName,
      logo: user.logo,
      companyEmail: user.companyEmail,
      noOfUsers: user.noOfUsers,
      isActive: user.isActive,
      licenseType: user.licenseType || LicenseType.Demo,  // Correctly mapping licenseType
      startDate: user.startDate ? this.utils.formatDate(this.selectedLicenceUser.startDate)
      : null,  // Ensure startDate is mapped correctly
      endDate: user.endDate ? this.utils.formatDate(this.selectedLicenceUser.endDate)
      : null,
      companyDetail: {
        id: user.companyDetail?.id || 0,
        companyId: user.companyDetail?.companyId || 0,
        connectionString: user.companyDetail?.connectionString || 'string',
        databaseName: user.companyDetail?.databaseName || 'string',
        authenticationMode: user.companyDetail?.authenticationMode || 'string',
      },
    });
    this.previewLogo = user.logo || 'assets/images/user/1.jpg';
    this.open(content);
  }
  openDbInitializeModal(user: UserLicence, content: any): void {
    this.companyIdForExecute = user.id;
    this.dbInitializePOV =1;
    this.open(content);
  }

  executeDB(): void{
    this.dbInitializePOV = 2;
  }
  testConnection(): void {
    const serverControl = this.initializeDbForm.get('server');

    if (serverControl?.value === 0) {
      this.toastrService.warning('Please select a server instance first before entering username and password.', 'Warning');
      return;
    }
    const databaseNameControl = this.initializeDbForm.get('databaseName');
    databaseNameControl?.clearValidators(); // Remove the required validation for database name during test connection
    databaseNameControl?.updateValueAndValidity();
    databaseNameControl?.disable();
    if (this.initializeDbForm.valid) {
      const formData = {
        ...this.initializeDbForm.value,
      };

      this.apiRequestService.postRequest('SSMS/test-connection', formData).subscribe(
        (response) => {
          this.toastrService.success('Connection successful!', 'Success');
          this.connectionData = {
            server: formData.server,
            username: formData.username,
            password: formData.password
          };
          this.testConnectionSuccess = true;
          databaseNameControl?.enable();
          databaseNameControl?.setValidators([Validators.required]); // Re-add validation
          databaseNameControl?.updateValueAndValidity();
        },
        (error) => {
          this.testConnectionSuccess = false;
          databaseNameControl?.disable();
          this.toastrService.error('Failed to connect to the server!', 'Error');
        }
      );
    }
  }

  BackToOne(): void{
    this.dbInitializePOV = 1;
  }
createDatabase(): void {
  if (this.initializeDbForm.valid) {
    const createDbData = {
      server: this.connectionData.server,
      username: this.connectionData.username,
      password: this.connectionData.password
    };
    this.databaseName= this.initializeDbForm.value.databaseName,
    this.loaderService.showLoader();
    this.apiRequestService.postRequest(`SSMS/create-database/${this.databaseName}`, createDbData).subscribe(
      (response) => {
        
        this.toastrService.success('Database created successfully!', 'Success');
        this.connectionDetails = {
          companyId: this.companyIdForExecute,  // Example, you should get the real companyId dynamically
          databaseName: this.databaseName,
          connectionDetails: {
            server: createDbData.server,
            username: createDbData.username,
            password: createDbData.password
          }
          

        };
        this.loaderService.hideLoader();
        this.dbInitializePOV = 2;
      },
      (error) => {
        this.toastrService.error('Failed to create database!', 'Error');
        this.loaderService.hideLoader();
      }
    );
  }
}
executeScript(): void {
  if (this.connectionDetails) {
    const formData = this.connectionDetails;
    this.loaderService.showLoader();
    this.apiRequestService.postRequest('SSMS/execute-scripts', formData).subscribe(
      (response) => {
        this.toastrService.success('Script executed successfully!', 'Success');
        // You can handle the success response, maybe show additional data or messages
        this.testConnectionSuccess = true; // Flag to show database name input
        this.loaderService.hideLoader();
      },
      (error) => {
        this.toastrService.error('Failed to execute the script!', 'Error');
        this.loaderService.hideLoader();
      }
    );
  } else {
    this.toastrService.error('Missing connection details!', 'Error');
    this.loaderService.hideLoader();
  }
}
cancelInitializeDbForm(modal: any): void {
  this.initializeDbForm.reset();
  this.testConnectionSuccess = false;
  modal.dismiss('Cross click');
}
  onSubmit(): void {
    if (this.licenceUserForm.valid) {
      const formData = {
        ...this.licenceUserForm.value,
        // licenseType: this.getLicenseTypeValue(this.licenceUserForm.value.licenseType),
        companyDetail: {
          id: 0,  // Static or default values
          companyId: 0,
          connectionString: 'string',
          databaseName: 'string',
          authenticationMode: 'string',
        },
      };
  
      if (this.mode === 'add') {
        this.apiRequestService.postRequest('License', formData).subscribe(
          (response) => {
            this.toastrService.success('License added successfully!', 'Success');
            this.modalService.dismissAll();
            this.getLicenceUsers();
          },
          (error) => {
            this.toastrService.error('Failed to add License!', 'Error');
          }
        );
      } else {
        this.apiRequestService.updateRequest(`License/${formData.id}`, formData).subscribe(
          (response) => {
            this.toastrService.success('License updated successfully!', 'Success');
            this.modalService.dismissAll();
            this.getLicenceUsers();
          },
          (error) => {
            this.toastrService.error('Failed to update License!', 'Error');
          }
        );
      }
    } else {
      this.toastrService.error('Please fill all required fields.', 'Validation Error');
    }
  }
  //change the enum to the reverse back integer
  getLicenseTypeValue(licenseType: any): number {
    switch (licenseType) {
      case this.licenceType.Demo:
        return 1; // Assuming Demo maps to 1
      case this.licenceType.Standard:
        return 2; // Assuming Full maps to 2
      case this.licenceType.Enterprise:
        return 3; // Assuming Trial maps to 3
      default:
        return 0; // Default case if something unexpected happens
    }
  }
  

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit - DataTable initialization triggered');
    this.dtTrigger.next(null); // Initialize DataTable when the component view is fully initialized
  }
  private reinitializeDataTable(): void {
    // Destroy existing DataTable instance if it exists
    if ($.fn.dataTable.isDataTable('#table1')) {
      $('#table1').DataTable().clear().destroy();
    }

    this.cdRef.detectChanges(); // Ensure the view is updated before reinitializing
    this.dtTrigger.next(null); // Trigger reinitialization
  }
  getLicenceUsers(): void {
    this.apiRequestService.getRequest<UserLicence[]>(`License/false`)
      .subscribe( async (response: HttpResponse<UserLicence[]>) => {
        if (response.body) {
          this.licenceUsers = response.body;

          this.reinitializeDataTable();
        }
      }, error => {
        this.toastrService.error('Failed to load Licence Users!', 'Error');
      });
  }
  getSqlInstances(): void {
    this.loaderService.showLoader();
    this.apiRequestService.getRequest(`SSMS`)
      .subscribe( async (response: any) => {
        if (response.body && response.body.length > 0) {
          this.sqlInstances = response.body;
          // this.loaderService.hideLoader();
        } else {
          this.sqlInstances = []; // If no instances are available, set empty array
          this.loaderService.hideLoader();
        }
        this.loadingInstance = false; // Stop loading once data is fetched
        this.errorInstance = false;   // Reset error flag
        this.loaderService.hideLoader();
      }, error => {
        this.loaderService.hideLoader();
        this.loadingInstance = false; // Stop loading if there's an error
        this.errorInstance = true;    // Set error flag
        this.toastrService.error('Failed to load Instance!', 'Error');
      });
  }
  deleteUserLicence(): void {
  
    this.apiRequestService.deleteRequest<UserLicence>(`License/${this.selectedLicenceUser?.id}`)
      .subscribe((response: HttpResponse<UserLicence>) => {
        
        if (response.status === 200) {
          
          this.toastrService.success('License deleted successfully!', 'Success');
          
          this.getLicenceUsers();
        } else {
          this.toastrService.error('Some error occurred!', 'Error');
        }
      }, err => {
        const error = err.error || 'Some error occurred!';
        this.toastrService.error(error, 'Error');
      })
  }
  
  deleteLicenceUser(content: any, department: UserLicence) {
    this.selectedLicenceUser = department; // Set the selected department to delete
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'md' })
      .result.then((result) => {
        if (result === 'Delete') {
          this.deleteUserLicence(); // Call the delete function
        }
        // Close modal and set focus to delete button (optional)
        this.setFocusToDeleteButton();
      }, (reason) => {
        // Just close the modal without any action
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.setFocusToDeleteButton();
      });
  }
    resetForm() {
      this.licenceUserForm.reset();
    }
    setFocusToDeleteButton() {
      // Ensure the element exists and focus on it
      const deleteButton = document.querySelector('.btn-outline-danger') as HTMLElement;
      if (deleteButton) {
        deleteButton.focus();
      }
    }
    onSliderChange(event: Event): void {
      const target = event.target as HTMLInputElement;
      this.licenceUserForm.patchValue({
        noOfUsers: target.valueAsNumber,
      });
    }
    ngOnDestroy(): void {
      if ($.fn.dataTable.isDataTable('#table1')) {
        $('#table1').DataTable().destroy();
      }
      this.dtTrigger.unsubscribe();
      window.removeEventListener('beforeunload', this.destroyDataTable);
    }
    private destroyDataTable = () => {
      if ($.fn.dataTable.isDataTable('#table1')) {
        $('#table1').DataTable().destroy();
      }
    };
}
